import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { wsDispatcher } from '@/assets/js/wsDispatcher';
export default {
  props: {
    initAnyWhereGlobalSetting: {
      type: Object,
      default: () => {}
    },
    initAudioMatrixEnable: {
      type: Boolean,
      default: false
    },
    initOperateData: {
      type: Object,
      default: () => {}
    },
    initResolution: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      locked: '0',
      fps: 60,
      fpsOptions: [{
        value: 60,
        label: 60
      }, {
        value: 50,
        label: 50
      }, {
        value: 30,
        label: 30
      }, {
        value: 25,
        label: 25
      }],
      resolution: '720',
      resolutionOptions: [{
        value: '2160p',
        label: '2160p'
      }, {
        value: '1080i',
        label: '1080i'
      }, {
        value: '1080p',
        label: '1080p'
      }, {
        value: '720p',
        label: '720p'
      }, {
        value: '480p',
        label: '480p'
      }],
      cameraPosition: '1',
      cameraOptions: [{
        value: '0',
        label: 'Selfie (Front-facing Camera)'
      }, {
        value: '1',
        label: 'Main (Rear Camera)'
      }, {
        value: '3',
        label: 'Main+Selfie (distant view)'
      }, {
        value: '4',
        label: 'Main+Selfie (near view)'
      }],
      defaultView: '0',
      defaultViewOptions: [{
        value: '0',
        label: 'fullScreen'
      }, {
        value: '1',
        label: 'partylineView'
      }],
      VolumEffects: [{
        value: true,
        label: 'meterOnPip'
      }, {
        value: false,
        label: 'audioLevel'
      }],
      defaultSwitch: {
        value: false,
        valueAudio: false,
        participantName: true,
        globalAnyWhereSetting: false,
        isAudioLevel: true,
        partyLinkShare: true,
        fullScreen: true,
        logOrRes: true,
        micOrCameraOperation: true,
        hotJar: true,
        hearParticipant: false,
        chatlio: false,
        intercom: false
      }
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      partyCode: state => state.partyCode
    }),
    computedFpsOptions() {
      if (this.resolution === '1080i') {
        // 如果是1080i，只保留帧率为50或60的选项
        return this.fpsOptions.filter(option => option.label === 50 || option.label === 60);
      } else {
        // 其他分辨率则返回所有fps选项
        return this.fpsOptions;
      }
    }
  },
  watch: {
    'initAnyWhereGlobalSetting.defaultView': {
      handler: function (newValue) {
        if (newValue) {
          this.defaultView = newValue;
        } else {
          this.defaultView = '0';
        }
      },
      immediate: true
    },
    'initAnyWhereGlobalSetting.lockScreen': {
      handler: function (newValue) {
        if (newValue) this.locked = newValue;
      },
      immediate: true
    },
    'initAnyWhereGlobalSetting.switchCamera': {
      handler: function (newValue) {
        if (newValue) {
          this.cameraPosition = newValue;
        } else {
          this.cameraPosition = '1';
        }
      },
      immediate: true
    },
    'initAnyWhereGlobalSetting.resolutionFps.interlace': {
      handler: function (newValue) {
        if (newValue == 1) {
          this.resolution = this.resolution + 'i';
        } else {
          this.resolution = this.resolution + 'p';
        }
      },
      immediate: true
    },
    'initAnyWhereGlobalSetting.resolutionFps.fps': {
      handler: function (newValue) {
        if (newValue) this.fps = newValue;
      },
      immediate: true
    },
    'initOperateData.anywhereGlobalSetting': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.globalAnyWhereSetting = true;
        } else {
          this.defaultSwitch.globalAnyWhereSetting = false;
        }
      },
      immediate: true
    },
    'initOperateData.hotJar': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.hotJar = true;
        } else {
          this.defaultSwitch.hotJar = false;
        }
      },
      immediate: true
    },
    'initOperateData.Chatlio': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.chatlio = true;
        } else {
          this.defaultSwitch.chatlio = false;
        }
      },
      immediate: true
    },
    'initOperateData.micCameraIconInPip': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.micOrCameraOperation = true;
        } else {
          this.defaultSwitch.micOrCameraOperation = false;
        }
      },
      immediate: true
    },
    'initOperateData.fullScreen': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.fullScreen = true;
        } else {
          this.defaultSwitch.fullScreen = false;
        }
      },
      immediate: true
    },
    'initOperateData.loginButton': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.logOrRes = true;
        } else {
          this.defaultSwitch.logOrRes = false;
        }
      },
      immediate: true
    },
    'initOperateData.hasCopy': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.partyLinkShare = true;
        } else {
          this.defaultSwitch.partyLinkShare = false;
        }
      },
      immediate: true
    },
    'initOperateData.lockName': {
      handler: function (newValue) {
        if (newValue || newValue === undefined) {
          this.defaultSwitch.participantName = true;
        } else {
          this.defaultSwitch.participantName = false;
        }
      },
      immediate: true
    },
    'initOperateData.intercom': {
      handler: function (newValue) {
        if (newValue) {
          this.defaultSwitch.intercom = true;
        } else {
          this.defaultSwitch.intercom = false;
        }
      },
      immediate: true
    },
    'initOperateData.volumeEffect': {
      handler: function (newValue) {
        if (newValue) {
          this.defaultSwitch.isAudioLevel = false;
        } else {
          this.defaultSwitch.isAudioLevel = true;
        }
      },
      immediate: true
    },
    'initResolution.videoQuality': {
      handler: function (newValue) {
        if (newValue === 'high') {
          this.defaultSwitch.value = true;
        } else if (newValue === 'low') {
          this.defaultSwitch.value = false;
        }
      },
      immediate: true
    },
    'initResolution.talkBack': {
      handler: function (newValue) {
        if (newValue === true) {
          this.defaultSwitch.valueAudio = true;
        } else if (newValue === false) {
          this.defaultSwitch.valueAudio = false;
        }
      },
      immediate: true
    },
    'initOperateData.hearThemSelf': {
      handler: function (newValue) {
        if (newValue) {
          this.defaultSwitch.hearParticipant = true;
        } else {
          this.defaultSwitch.hearParticipant = false;
        }
      },
      immediate: true
    }
  },
  created() {
    var _this$initOperateData, _this$initOperateData2;
    this.State.initIntercomEnable = this.State.intercomEnable = !!((_this$initOperateData = this.initOperateData) !== null && _this$initOperateData !== void 0 && _this$initOperateData.intercom);
    this.State.initAudioMatrixEnable = this.State.audioMatrixEnable = this.initAudioMatrixEnable;
    this.State.initPushToTalk = this.State.pushTalkEnable = !!((_this$initOperateData2 = this.initOperateData) !== null && _this$initOperateData2 !== void 0 && _this$initOperateData2.pushToTalk);
    const enabledCount = [this.State.initPushToTalk, this.State.initAudioMatrixEnable, this.State.initIntercomEnable].filter(Boolean).length;
    if (enabledCount >= 2 && this.State.initIntercomEnable) {
      this.changeParticipantsPrivate(false, 'noMessage');
      this.defaultSwitch.intercom = false;
    }
    this.wsAddEventListener();
    Bus.$on('videoQuality', val => {
      if (val.videoQuality === 'high') {
        this.defaultSwitch.value = true;
      } else {
        this.defaultSwitch.value = false;
      }
    });
    Bus.$on('setLoginScreenButton', val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 6) {
        if (operationType === 0) {
          this.defaultSwitch.hearParticipant = false;
        } else {
          this.defaultSwitch.hearParticipant = true;
        }
      }
    });
  },
  methods: {
    wsAddEventListener() {
      wsDispatcher.register('setTalkBack', this.setTalkBack, 'participantSetTalkBack');
      wsDispatcher.register('cancelTalkBack', this.cancelTalkBack, 'participantCancelTalkBack');
    },
    setTalkBack() {
      this.defaultSwitch.valueAudio = true;
    },
    cancelTalkBack() {
      this.defaultSwitch.valueAudio = false;
    },
    changeProperty(type, value) {
      const arrayParams = [];
      this.params = {
        partyCode: Number(this.partyCode),
        setting: {
          key: type
        }
      };
      if (type == 'resolutionFps') {
        var _this$resolution;
        // 如果选择的是1080i且fps为25或30,则将fps设置为50
        if (value == '1080i' && (this.fps == '25' || this.fps == '30')) {
          this.fps = '50';
        }
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            height: Number((_this$resolution = this.resolution) === null || _this$resolution === void 0 ? void 0 : _this$resolution.replace(/(p|i)$/, '')),
            fps: Number(this.fps),
            interlace: this.resolution == '1080i' ? 1 : 0
          })
        };
      } else if (type == 'switchCamera') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            position: this.cameraPosition
          })
        };
      } else if (type == 'defaultView') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            display: this.defaultView
          })
        };
      } else if (type == 'lockScreen') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            lock: this.locked
          })
        };
      }
      arrayParams.push(this.params);
      this.axios.post('/partyline-backend/anywhere/globalSetting', arrayParams).then(res => {
        if (res.data.errorCode != '0x0') {
          this.$message({
            type: 'error',
            message: res.data.errorMessage
          });
        } else {
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    applyDefaultAnyWhereSettings() {
      var _this$resolution2;
      const arrayParams = [{
        partyCode: this.partyCode,
        setting: {
          key: 'defaultView',
          value: JSON.stringify({
            display: this.defaultView
          })
        }
      }, {
        partyCode: this.partyCode,
        setting: {
          key: 'switchCamera',
          value: JSON.stringify({
            position: this.cameraPosition
          })
        }
      }, {
        partyCode: this.partyCode,
        setting: {
          key: 'resolutionFps',
          value: JSON.stringify({
            height: Number((_this$resolution2 = this.resolution) === null || _this$resolution2 === void 0 ? void 0 : _this$resolution2.replace(/(p|i)$/, '')),
            fps: Number(this.fps),
            interlace: this.resolution == '1080i' ? 1 : 0
          })
        }
      }, {
        partyCode: this.partyCode,
        setting: {
          key: 'lockScreen',
          value: JSON.stringify({
            lock: this.locked
          })
        }
      }];
      this.axios.post('/partyline-backend/anywhere/globalSetting', arrayParams).then(res => {
        if (res.data.errorCode != '0x0') {
          this.$message({
            type: 'error',
            message: res.data.errorMessage
          });
        } else {
          this.$message.success(this.$t('setting.OpenGlobalAnyWhere'));
        }
      });
    },
    changeGlobalAnyWhereSetting(value) {
      const params = {
        buttonType: 19,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          if (!this.defaultSwitch.globalAnyWhereSetting) {
            this.$emit('changeButtonFlag', 0, 'globalAnyWhereButton');
            this.$message.success(this.$t('setting.OffGlobalAnyWhere'));
          } else {
            this.applyDefaultAnyWhereSettings();
            this.$emit('changeButtonFlag', 1, 'globalAnyWhereButton');
          }
        }
      });
    },
    showMutexTip() {
      if (this.State.audioMatrixEnable || this.State.pushTalkEnable) {
        this.$emit('mutexTip');
      }
    },
    updateVolumeStyle(value) {
      const params = {
        buttonType: 17,
        operationType: value ? 0 : 1
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          // let message = this.$t('remainWords.hostChangeAudioLevel')
          if (!this.defaultSwitch.isAudioLevel) {
            this.$emit('changeButtonFlag', 1, 'volumeEffect');
            // message = this.$t('remainWords.hostChangeAudioBar')
          } else {
            this.$emit('changeButtonFlag', 0, 'volumeEffect');
          }
          // this.$message.success(message)
        }
      });
    },

    // 控制与会者的分辨率
    changeResolution(value) {
      if (!this.partyCode) return;
      // 上报分辨率
      const params = {
        partyCode: this.partyCode,
        module: 'videoQuality',
        msg: {
          videoQuality: value ? 'high' : 'low'
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=79281', params).then(data => {
        if (data.data.errorCode === '0x0') {
          let message = this.$t('setting.OffHighResolution');
          if (this.defaultSwitch.value) {
            message = this.$t('setting.OnHighResolution');
          }
          this.$message.success(message);
          const value = this.defaultSwitch.value ? 'high' : 'low';
          this.$emit('changeButtonFlag', value, 'resolution');
        }
      });
    },
    // 控制与会者的lazyAudio
    changeLazyAudio(value) {
      this.axios.post('/partyline-backend/party/noLogin/command?key=81160', {
        partyCode: this.partyCode,
        module: value ? 'setTalkBack' : 'cancelTalkBack',
        msg: {}
      }).then(data => {
        if (data.data.errorCode === '0x0') {
          let message = this.$t('addWords.turnOffLazyAudio');
          if (this.defaultSwitch.valueAudio) {
            message = this.$t('addWords.turnOnLazyAudio');
          }
          this.$emit('changeButtonFlag', this.defaultSwitch.valueAudio, 'lazyAudio');
          this.$message.success(message);
        }
      });
    },
    changeParticipantsPrivate(value, noMessage) {
      this.State.intercomEnable = value;
      const params = {
        buttonType: 12,
        operationType: value ? 1 : 0,
        data: {
          hostRtilCode: this.State.partyJoinInfo.rtilCode
        }
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          if (!this.defaultSwitch.intercom) {
            this.$emit('changeButtonFlag', 0, 'intercom');
          } else {
            this.$emit('changeButtonFlag', 1, 'intercom');
          }
          if (!noMessage) {
            this.$message.success(this.$t('commonFunction.operateSuccessful'));
          }
        }
      });
    },
    changeLockPipName(value) {
      const params = {
        buttonType: 4,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          let message = this.$t('setting.unlockNameTips');
          if (!this.defaultSwitch.participantName) {
            this.$emit('changeButtonFlag', 0, 'lockName');
            message = this.$t('setting.lockNameTips');
          } else {
            this.$emit('changeButtonFlag', 1, 'lockName');
          }
          this.$message.success(message);
        }
      });
    },
    // 控制与会者的Copy按钮
    changePipCopyBtn(value) {
      const params = {
        buttonType: 1,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          let message = this.$t('commonFunction.showInviteButtonTips');
          if (!this.defaultSwitch.partyLinkShare) {
            this.$emit('changeButtonFlag', 0, 'hasCopy');
            message = this.$t('commonFunction.hideInviteButtonTips');
          }
          if (this.defaultSwitch.partyLinkShare) {
            this.$emit('changeButtonFlag', 1, 'hasCopy');
          }
          this.$message.success(message);
        }
      });
    },
    // 控制与会者的登录注册
    changePipLoginOrRes(value) {
      const params = {
        buttonType: 0,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          let message = this.$t('setting.loginShownMessage');
          if (!this.defaultSwitch.logOrRes) {
            this.$emit('changeButtonFlag', 0, 'login');
            message = this.$t('setting.loginHiddenMessage');
          }
          if (this.defaultSwitch.logOrRes) {
            this.$emit('changeButtonFlag', 1, 'login');
          }
          this.$message.success(message);
        }
      });
    },
    sendMuteAll() {
      const params = {
        buttonType: 13,
        operationType: 1
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('setting.muteAllSuccess'));
        }
      });
    },
    // 控制与会者的底部区域的全屏按钮
    changePipFullScreen(value) {
      const params = {
        buttonType: 2,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          let message = this.$t('setting.fullScreenShowMessage');
          if (!this.defaultSwitch.fullScreen) {
            this.$emit('changeButtonFlag', 0, 'fullScreen');
            message = this.$t('setting.fullScreenHiddenMessage');
          }
          if (this.defaultSwitch.fullScreen) {
            this.$emit('changeButtonFlag', 1, 'fullScreen');
          }
          this.$message.success(message);
        }
      });
    },
    // 控制与会者的麦克风和摄像头
    changePipMicOrCamera(value) {
      const params = {
        buttonType: 3,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          let message = this.$t('setting.micAndCameraShowMessage');
          if (!this.defaultSwitch.micOrCameraOperation) {
            this.$emit('changeButtonFlag', 0, 'mic');
            message = this.$t('setting.micAndCameraHiddenMessage');
          }
          if (this.defaultSwitch.micOrCameraOperation) {
            this.$emit('changeButtonFlag', 1, 'mic');
          }
          this.$message.success(message);
        }
      });
    },
    // 控制hotJar
    changePipHotJar(value) {
      const params = {
        buttonType: 5,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          let message = this.$t('setting.hotJarShowMessage');
          if (!this.defaultSwitch.hotJar) {
            this.$emit('changeButtonFlag', 0, 'hotJar');
            message = this.$t('setting.hotJarHiddenMessage');
          }
          if (this.defaultSwitch.hotJar) {
            this.$emit('changeButtonFlag', 1, 'hotJar');
          }
          this.$message.success(message);
        }
      });
    },
    // 控制 chatlio
    changePipChatlio(value) {
      const params = {
        buttonType: 8,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$emit('changeButtonFlag', value ? 1 : 0, 'chatlio');
          this.$message.success(value ? this.$t('setting.chatlioShowMessage') : this.$t('setting.chatlioHideMessage'));
        }
      });
    },
    changePipCanHear(value) {
      const params = {
        buttonType: 6,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          value ? this.State.startHearSelf = true : this.State.startHearSelf = false;
          this.$emit('changeButtonFlag', value, 'hearThemSelf');
          this.$message.success(this.$t('setting.audioBackOperateSuccess'));
        }
      });
    },
    handleScroll() {
      const scrollT = this.$refs.pipScroll.scrollTop;
      if (scrollT > 0) {
        Bus.$emit('showTitleShadow', true);
      } else {
        Bus.$emit('showTitleShadow', false);
      }
    }
  },
  mounted() {
    const that = this;
    const participantListContent = document.getElementById('myScroll');
    participantListContent.addEventListener('scroll', that.handleScroll, true);
  },
  beforeDestroy() {
    Bus.$off('showTitleShadow');
    wsDispatcher.unregister('setTalkBack', 'participantSetTalkBack');
    wsDispatcher.unregister('cancelTalkBack', 'participantCancelTalkBack');
  }
};